import { render, staticRenderFns } from "./ProfileField.vue?vue&type=template&id=dbd13be2&"
import script from "./ProfileField.vue?vue&type=script&lang=js&"
export * from "./ProfileField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports